<!-- eslint-disable vue/valid-v-bind -->
<template>
  <Wallet :mobile_wallet_show_settings="isMobileWalletShowSettings" :is_micro_view="isMicroView" @touchstart.native="walletSwipeStart" @touchend.native="walletSwipeEnd">
    <!-- @touchmove.native="walletSwipeMove" -->
    
        <template #snackbar>
          <SnackBar v-if="snackbar.show" :snackbar="snackbar" @updateSnackbar="updateSnackbar($event)">
            <template #activator>
              <Activator class="self-centered cursor-s-resize" :key="`snackbar_activator`"
                @mousedown.native="updateSnackbar({ show: false, hover: false, selector: false })" />
            </template>

            <template #header>
              <template v-if="snackbar.action === 'create'">

              <!-- snackbar for creating elements in work steps -->
              <div class="takt-plan-snack-bar-head">
                <template v-if="snackbar.target_type === 'substeps'">
                  <TText text="Create substep for aditional steps" />
                    <!-- <TText v-for="step_id in snackbar.affected_parents" :key="step_id" :text="getText(step_id)"/> -->
                  <!-- <TWorkPackage v-for="step_id in snackbar.affected_parents" :key="step_id" class="ma-2" :workpackage_count="1" :zoom="1" :workpackage="getWorkPackage(step_id)" /> -->
                  <!-- <TText text="for WORK.step:" /> -->
                </template>
              </div>
              </template>

              <template v-else-if="snackbar.action === 'update'">
                <div>
                  <TText value="Update {number} aditional substeps" :value_props="{number: getAffectedTargets.length}"/>
                </div>
              </template>

              <templat v-else-if="snackbar.action === 'delete'">
                <div>
                  <TText value="delete aditional steps" />
                </div>
              </templat>
            </template>

            <template #body>
              <template v-if="snackbar.action === 'update' || snackbar.action === 'delete' || snackbar.action === 'create'">
                <div>
                  <SnackBarStepItem
                    :step="getUObject({type: snackbar.parent_type, id: snackbar.parent_id})" 
                    :step_type="snackbar.parent_type.substring(1, snackbar.parent_type.length - 5)" 
                    :background_color="getUObjectParent({
                      parent_type: 'tworkpackages',
                      type: snackbar.parent_type,
                      id: snackbar.parent_id
                      }).color" 
                    :foreground_color="getUObjectParent({
                      parent_type: 'tworkpackages',
                      type: snackbar.parent_type,
                      id: snackbar.parent_id
                      }).textcolor"
                  />
                  <!-- <TText :text="getUObject({type: snackbar.parent_type, id: snackbar.parent_id}).text"/> -->
                </div>
              </template>
            </template>

            <template #footer>
          <!-- <TFlex justify_content="space-around" align_items="center" class="mt-1 mb-1"> -->
          <div class="takt-plan-snack-bar-footer">

            <div class="takt-plan-snack-bar-footer-buttons">
              <ButtonOutlined text="Close" @buttonClicked="updateSnackbar({ show: false, hover: false, affected_additional_targets: false, bim_process: false, response_elements: false, selector: false })" />
              <ButtonOutlined
                :text="`Apply (${snackbar.action === 'create' ? snackbar.affected_parents.length : getAffectedTargets.length})`"
                color="green lighten-1" @buttonClicked="applySnackbar()" />
            </div>
          </div>
          <!-- </TFlex> -->
        </template>
          </SnackBar> 
        </template>
    <template #settings>
      <PrintDialog v-if="$store.state.View.is_printing_mode" name="Wallet" :file_name="getProjectName"
        print_el="wallet-content-container" height_el="wallet-content-container" width_el="wallet-content-container"
        />
      <WalletSettings>
        <v-icon>sort</v-icon>
        <div :style="`padding-top: 4px;`">
          <StandardOverflowButton
            tooltip="Sort by Train"
            ticon="takt-plan-train"
            :value="{trains: getWalletSettings.trains.length === 0?[getStatisticsTrainSelector(project_id)[0].value]:getWalletSettings.trains}"
            :options="{trains: getStatisticsTrainSelector(project_id)}"
            :button_color="getWalletSettings.sorting === 'trains' ? 'color-3' : ''"
            :multiselect="true"
            @select-option="setWalletSettings({setting: $event.setting, value: $event.value})"
          />
          <!-- @button-clicked="setWalletSettings({setting: 'sorting', value: 'trains'})" -->
          <StandardOverflowButton
            tooltip="Sort by Color"
            :value="{colors: getWalletSettings.colors.length === 0?[getTWorkpackageColors[0].value]:getWalletSettings.colors}"
            :options="{colors: getTWorkpackageColors}"
            :button_color="getWalletSettings.sorting === 'colors' ? 'color-3' : ''"
            :multiselect="true"
            @select-option="setWalletSettings({setting: $event.setting, value: $event.value})"
            />
            <!-- @button-clicked="setWalletSettings({setting: 'sorting', value: 'colors'})" -->
          <StandardOverflowButton
            tooltip="Sort by Status"
            :value="{status: getWalletSettings.status.length === 0?[getFullStatusArray[0].value]:getWalletSettings.status}"
            :options="{status: getFullStatusArray}"
            :button_color="getWalletSettings.sorting === 'status' ? 'color-3' : ''"
            :multiselect="true"
            @select-option="setWalletSettings({setting: $event.setting, value: $event.value})"
            />
          <StandardOverflowButton
            tooltip="Sort by Icon"
            :icon_new="getWalletSettings.icons.length === 0?[getTWorkpackageIcons[0].value]:getWalletSettings.icons"
            :value="{icons: getWalletSettings.icons.length === 0?[getTWorkpackageIcons[0].value]:getWalletSettings.icons}"
            :options="{icons: getTWorkpackageIcons}"
            :button_color="getWalletSettings.sorting === 'icons' ? 'color-3' : ''"
            :multiselect="true"
            @select-option="setWalletSettings({setting: $event.setting, value: $event.value})"
          />
          <!-- @button-clicked="setWalletSettings({setting: 'sorting', value: 'status'})" -->
          <TTooltip value="Reset_Sort">
            <button
              :class="`ticon-button`"
              @click="resetWalletSettings({
                  setting: 'trains',
                  value: getStatisticsTrainSelector(project_id)[0].value
                })"
            >
              <TIcon
                name="restart"
              />
            </button>
          </TTooltip>
          <v-divider class="mt-1 mb-2" width="100%" color="white"></v-divider>

          <StandardOverflowButton
            tooltip="Filter Steps"
            ticon="filter"
            icon="filter_alt"
            :multiselect="true"
            :button_color="getWalletSettings.filter? 'color-3':''"
            :button_color_selected="'grey darken-1'"
            :value="{
              steps: getWalletSettings.steps
              }"
            :options="{
              steps: isWalletShowWorkpackages?
              [
                {icon: $store.state.Ultra.step_icons['quality'], ticon: $store.state.Ultra.step_icons['quality'], value: $t('Project.Wallet.Filter[1]'), tooltip: 'Quality'},
                {icon: $store.state.Ultra.step_icons['defect'], ticon: $store.state.Ultra.step_icons['defect'], value: $t('Project.Wallet.Filter[2]'), tooltip: 'Defect'},
                {icon: $store.state.Ultra.step_icons['handover'], ticon: $store.state.Ultra.step_icons['handover'], value: $t('Project.Wallet.Filter[3]'), tooltip: 'Handover'},
                {icon: $store.state.Ultra.step_icons['logistic'], ticon: $store.state.Ultra.step_icons['logistic'], value: $t('Project.Wallet.Filter[4]'), tooltip: 'Logistic'},
                {icon: $store.state.Ultra.step_icons['design'], ticon: $store.state.Ultra.step_icons['design'], value: $t('Project.Wallet.Filter[5]'), tooltip: 'Design'},
              ]
              :
              [
                {icon: $store.state.Ultra.step_icons['work'], ticon: $store.state.Ultra.step_icons['work'], value: $t('Project.Wallet.Filter[0]'),  tooltip: 'Work'},
                {icon: $store.state.Ultra.step_icons['quality'], ticon: $store.state.Ultra.step_icons['quality'], value: $t('Project.Wallet.Filter[1]'), tooltip: 'Quality'},
                {icon: $store.state.Ultra.step_icons['defect'], ticon: $store.state.Ultra.step_icons['defect'], value: $t('Project.Wallet.Filter[2]'), tooltip: 'Defect'},
                {icon: $store.state.Ultra.step_icons['handover'], ticon: $store.state.Ultra.step_icons['handover'], value: $t('Project.Wallet.Filter[3]'), tooltip: 'Handover'},
                {icon: $store.state.Ultra.step_icons['logistic'], ticon: $store.state.Ultra.step_icons['logistic'], value: $t('Project.Wallet.Filter[4]'), tooltip: 'Logistic'},
                {icon: $store.state.Ultra.step_icons['design'], ticon: $store.state.Ultra.step_icons['design'], value: $t('Project.Wallet.Filter[5]'), tooltip: 'Design'},
                /* {icon: $store.state.Ultra.step_icons['material'], ticon: $store.state.Ultra.step_icons['material'], value: $t('Project.Wallet.Filter[6]'), tooltip: 'Material'},
                {icon: $store.state.Ultra.step_icons['machine'], ticon: $store.state.Ultra.step_icons['machine'], value: $t('Project.Wallet.Filter[7]'), tooltip: 'Machine'}, */
              ]
            }
              "
            @button-clicked="setWalletSettings({setting: 'filter', value: !getWalletSettings.filter})"
            @select-option="setWalletSettings({setting: $event.setting, value: $event.value}),
                            setWalletSettings({setting: 'filter', value: true})
            "
            />
          <TTooltip value="Reset_Filter">
            <button
              :class="`ticon-button`"
              @click="resetWalletStepFilter()"
            >
              <TIcon
                name="restart"
              />
            </button>
          </TTooltip>

          <v-divider class="mt-2 mb-2" width="100%" color="white"></v-divider>

          <TIconButton
            :is_clicked="!isWalletShowWorkpackages"
            icon="takt-plan-workpackage"
            :tooltip="isWalletShowWorkpackages ? 'Hide_Workpackages' : 'Show_Workpackages'"
            @clickIcon="setWalletShowWorkpackages(!isWalletShowWorkpackages)"
          />
          <template v-if="$vuetify.breakpoint.smAndDown">
            <v-divider class="ma-0" width="100%" color="white"></v-divider>
            <div class="wallet-sidebar">
            <v-btn
              icon
              @click="$router.push({
                name: 'ProjectWalletTakt',
                params: {
                  takt_index: parseInt($route.params.takt_index) - parseInt(1),
                  direction: 'left'
                }
                })"
              >
              <!-- <v-icon>keyboard_arrow_left</v-icon> -->
              <TIcon name="chevron-left"/>
            </v-btn>
            <v-btn
              icon
              @click="$router.push({
                name: 'ProjectWalletTakt',
                params: {
                  takt_index: getCurrentTaktIndex($route.params.project_id) !== false?
                              Math.abs(getCurrentTaktIndex($route.params.project_id)):1,
                  direction: 'none',
                }
                })"
              >
              <!-- <v-icon>today</v-icon> -->
              <TIcon name="calendar" />
            </v-btn>
            <v-btn
              icon
              @click="$router.push({
                name: 'ProjectWalletTakt',
                params: {
                  takt_index: parseInt($route.params.takt_index) + parseInt(1),
                  direction: 'right',
                }
                })"
              >
              <!-- <v-icon>keyboard_arrow_right</v-icon> -->
              <TIcon name="chevron-right" />
            </v-btn>
            </div>
          </template>
        </div>
      </WalletSettings>
    </template>

    <template #left>
        <transition :name="`wallet-slide-${$route.params.direction}`">
            <router-view :key="$route.params.takt_index" :name="isMicroView? 'center' : 'left'" />
        </transition>
    </template>

    <template #center v-if="isMicroView">
        <div class="microlevel">
            <div class="microlevel-header">
              <div class="d-flex"/>

              <div class="d-flex" v-if="microlevel_taktarea_filter.length !== 0">
                <TText
                    value="Filter by Taktarea:"
                    font_weight="400"
                    large
                  />
                  <TText
                    :text="$store.state.Ultra.taktareas[microlevel_taktarea_filter[0]].name"
                    font_weight="400"
                    large
                  />
                  <v-btn
                    small
                    class="ml-2"
                    @click="setValue({key: 'microlevel_taktarea_filter', value: []})"
                  >
                    <TText
                      value="reset filter"
                      font_weight="400"
                    />
              </v-btn>
              </div>
              <ButtonOutlined
                class="mr-2 mt-2"
                padding="0 8px"
                height="48"
                @buttonClicked="setValue({ key: 'isShowMicroGrid', value: !isShowMicroGrid })"
              >
                <template #text>
                  <RadialCheckbox
                    :is_checked="isShowMicroGrid"
                  />
                  <TText
                    value="Show Grid"
                    font_weight="400"
                  />
                </template>
              </ButtonOutlined>
            </div>
            <div class="microlevel-body">
              <div class="microlevel-time">
                <div
                  class="microlevel-time-slot"
                  v-for="slot in microlevel_time_slots"
                  :key="`timeslot_header_${slot.start}`"
                  :style="`
                    height: calc(100% * ${slot.duration / working_time_duration});
                  `"
                >
                  <TText class="microlevel-time-slot-header" :text="slot.show_start_time ? slot.start_time_string :''" />
                </div>
              </div>
              <div
                class="microlevel-day"
                v-for="(day, day_index) in microlevel_takt_days"
                :key="`microlevel_day${day_index}`"
                :style="`width: calc((100% - 50px) / ${microlevel_takt_days.length}`"
              >
                <TText class="microlevel-day-header" :text="day" />
                <div class="microlevel-day-body" :style="`border-color: ${$vuetify.theme.isDark ? '#ffffff82' : '#00000082'}`">
                  <SubStep
                    v-show="substep_cache.show && substep_cache.day_index === day_index"
                    :key="`substep_cache${day_index}${substep_cache.show}${substep_cache.start}${substep_cache.duration}${substep_cache.day_index}`"
                    :substep="substep_cache"
                    :working_time_start="working_time_start"
                    :working_time_duration="working_time_duration"
                    :max_x_index="microlevel_substeps[day_index].max_x_index"
                    style="z-index: 40"
                    :show_length_handler="!isShowMicroGrid"
                    @mousedownBody="subStepMouseDown(substep_cache, 'body')"
                    @mousedownHandlerTop="subStepMouseDown(substep_cache, 'top')"
                    @mousedownHandlerBottom="subStepMouseDown(substep_cache, 'bottom')"
                  />
                  <SubStep
                    v-for="substep in microlevel_substeps[day_index].steps.filter(filterByTaktarea)"
                    :key="`substep_${substep.id}`"
                    :substep="substep"
                    :working_time_start="working_time_start"
                    :working_time_duration="working_time_duration"
                    :max_x_index="microlevel_substeps[day_index].max_x_index"
                    :selected="selected_substep.id === substep.id"
                    :moving="substep_cache.show && substep_cache.id === substep.id"
                    :show_length_handler="!isShowMicroGrid"
                    style="cursor: pointer;"
                    @click.native="clickSubStep(substep)" 
                    @mousedownBody="subStepMouseDown(substep, 'body')"
                    @mousedownHandlerTop="subStepMouseDown(substep, 'top')"
                    @mousedownHandlerBottom="subStepMouseDown(substep, 'bottom')"
                  />
                  <!-- visible slots  -->
                  <div style="position: absolute; width: 100%; height: 100%; z-index: 0">
                    <div
                      v-for="slot in microlevel_time_slots"
                      :class="`microlevel-time-slot`"
                      :key="`timeslot_body_${slot.start}`"
                      :style="`
                        height: calc(100% * ${slot.duration / working_time_duration});
                        border-top: ${slot.show_start_time ? `1px solid ${$vuetify.theme.isDark ? '#ffffff82' : '#00000082'}` : 'none'};
                        border-bottom: ${slot.show_end_time ? `1px solid ${$vuetify.theme.isDark ? '#ffffff82' : '#00000082'}` : 'none'};
                        ${slot.is_grid?`background-color: ${getColor('color-3')};`:''}
                      `"
                      @dblclick="slot.is_valid_slot?
                        createSubStep(slot, day_index, $event)
                        :
                        ''
                      "
                      @click="
                      selected_substep = {id: -1},
                      substep_cache.show = false
                      "
                    />
                  </div>
                  <!-- invisible slots for interaction-->
                  <div v-show="show_interaction_slots" style="position: absolute; width: 100%; height: 100%; z-index: 50">
                    <div
                      v-for="slot in microlevel_time_slots"
                      :class="`microlevel-time-slot-invisible`"
                      :key="`invisible_timeslot_body_${slot.start}`"
                      :style="`
                        height: calc(100% * ${slot.duration / working_time_duration});
                      `"
                      @click="slot.is_valid_slot
                        ? createSubStep(slot, day_index, $event)
                        : ''
                      "
                      @mouseenter="slotMouseEnter(slot, day_index)"
                    />
                  </div>
                </div>
              </div>
            </div>
        </div>
        
    </template>

    <template #center v-else>
        <transition :name="`wallet-slide-${$route.params.direction}`">
            <router-view :key="$route.params.takt_index" name="center" />
        </transition>
    </template>

    <template #right v-if="!isMicroView">
        <transition :name="`wallet-slide-${$route.params.direction}`">
            <router-view :key="$route.params.takt_index" name="right" />
        </transition>
    </template>
  </Wallet>
</template>

<script>
import PrintDialog from '@/components/StandardComponents/PrintDialog.component.vue';
import store from '@/store/index';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
import SnackBar from '@/components/ProjectTaktPlan/SnackBar.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'
import SnackBarStepItem from '@/modules/WorkPackageWIP/SnackBarStepItem.module.vue';

// import FillableCell from '@/components/WorkPackageWIP/FillableCell.component.vue';
// import SnackBarStepItem from '@/modules/WorkPackageWIP/SnackBarStepItem.module.vue';
// import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
// import TWaggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import { WalletMixin } from '@/mixins/Wallet.mixin.js';
import { TColor } from '@/mixins/TColor.mixin.js';
import {
    mapActions,
    mapGetters,
    mapState,
} from 'vuex';

export default {
    props: ['project_id', 'snackbar'],
    components: {
        PrintDialog,
        ButtonOutlined,
        RadialCheckbox,
        SnackBar,
        Activator,
        SnackBarStepItem
        // FillableCell,
        // SnackBarStepItem,
        // TWorkPackage,
        // TWaggon
    },
    mixins: [
        WalletMixin,
        TColor,
    ],
    created() {
      let takt_index = this.getCurrentTaktIndex(this.project_id) !== false ? Math.abs(this.getCurrentTaktIndex(this.project_id)) : 1;
      if (this.$route.params.calculate_takt_time && takt_index !== 1) {
          this.$router.push({
              name: 'ProjectWalletTakt',
              params: {
                  takt_index: takt_index,
                  calculate_takt_time: false,
                  direction: 'all'
              }
          });
      }
      let self = this;
      window.addEventListener('keyup', function(evt) {
        if (evt.code === 'Backspace' && self.selected_substep.id !== -1) {
          let substep = self.selected_substep;
          let step_type = substep.step_type_short;
          let step_id = substep.step_id;
          let takt_index = self.$route.params.takt_index;
          let step_card = self.$store.state.Ultra.projects[self.project_id].step_cards[takt_index][`${step_type}_cards`].find(card => card.id === step_id);
          let train_id = step_card.train_id;
          let taktarea_id = step_card.taktarea_id;
          let twaggon_id = step_card.twaggon_id;
          let tworkpackage_id = step_card.work_package_id;
          self.deleteUObject({
            url: [
              { projects: self.project_id },
              { trains: train_id },
              { taktareas: taktarea_id },
              { twaggons: twaggon_id },
              { tworkpackages: tworkpackage_id },
              { [`t${step_type}steps`]: step_id },
              { substeps: substep.id},
            ]
          }).then(() => {
            self.selected_substep = {id: -1};
          });
        } else if (evt.code === 'Escape') {
          self.selected_substep = {id: -1};
        }
      });
      window.addEventListener('mousemove', function(evt) {
        if (self.is_mouse_down && !self.is_mouse_moved) {
          self.subStepMouseMove(evt);
        }
      });
      window.addEventListener('mouseup', function() {
        self.is_mouse_down = false;
        if (self.is_mouse_moved) {
          self.show_interaction_slots = false;
          // save changes
          if (self.substep_cache.id !== 'create') {
            self.saveSubStep('update')
          }
        }
      });
    },
    beforeDestroy() {
      window.removeEventListener('keyup');
      window.removeEventListener('mousemove');
      window.removeEventListener('mouseup');
    },
    watch: {
      '$route.params.takt_index': function(val) {
        this.requestMicroLevel({project_id: this.project_id, takt_index: val});
      },
      new_substep_step_id: function(val) {
        if (val !== -1 && this.new_substep_search_step_id && this.substep_cache.show) {
          // create new substep
          this.substep_cache.step_type_short = this.new_substep_step_type;
          this.substep_cache.step_id = this.new_substep_step_id;
          this.saveSubStep('create');
        }
      },
      'substep_cache.show': function(val) {
        if (val === false) {
          this.setValue({key: 'new_substep_step_id', value: -1}),
          this.setValue({key: 'new_substep_step_type', value: false}),
          this.setValue({key: 'new_substep_search_step_id', value: false})
        }
      }
    },
    computed: {
        ...mapState('View', [
            'isMicroView',
            'isShowMicroGrid',
        ]),
        ...mapGetters('ProjectCalendar', [
            'getCurrentTaktIndex',
        ]),
        ...mapGetters('SnackBar', [
          'getAffectedTargets'
        ]),
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch('ProjectWallet/resetWalletSettings', {
                setting: 'trains',
                value: store.getters['Project/getProject'](to.params.project_id).trains[0],
            })
            .then(() => {
                store.dispatch('ProjectWallet/requestProjectStepCards', {
                        project_id: to.params.project_id,
                        takt_index: to.params.takt_index - 1,
                    })
                    .then(() => {
                        store.dispatch('ProjectWallet/requestProjectStepCards', {
                                project_id: to.params.project_id,
                                takt_index: to.params.takt_index,
                            })
                            .then(() => {
                                store.dispatch('ProjectWallet/requestProjectStepCards', {
                                        project_id: to.params.project_id,
                                        takt_index: parseInt(to.params.takt_index) + parseInt(1),
                                    })
                                    .then(() => {
                                        next();
                                    });
                            });
                    });
            });
    },
    beforeRouteUpdate(to, from, next) {
        if (from.params.takt_index !== to.params.takt_index) {
            if (to.params.direction === 'all') {
                store.dispatch('ProjectWallet/requestProjectStepCards', {
                        project_id: to.params.project_id,
                        takt_index: to.params.takt_index - 1,
                    })
                    .then(() => {
                        store.dispatch('ProjectWallet/requestProjectStepCards', {
                                project_id: to.params.project_id,
                                takt_index: to.params.takt_index,
                            })
                            .then(() => {
                                store.dispatch('ProjectWallet/requestProjectStepCards', {
                                        project_id: to.params.project_id,
                                        takt_index: parseInt(to.params.takt_index) + parseInt(1),
                                    })
                                    .then(() => {
                                        next();
                                    });
                            });
                    });
            } else {
                let takt_index = to.params.takt_index + 1
                if (to.params.direction === 'left') {
                    takt_index = to.params.takt_index - 1
                }
                store.dispatch('ProjectWallet/requestProjectStepCards', {
                        project_id: to.params.project_id,
                        takt_index: takt_index,
                    })
                    .then(() => {
                        next();
                    });
            }
        } else {
            next();
        }
    },
    methods: {
      ...mapActions('Project', [
      'requestMicroLevel'
      ]),
      filterByTaktarea(substep){
        if(this.microlevel_taktarea_filter.length){
          return this.microlevel_taktarea_filter.includes(substep.taktarea_id);
        }
        return true;
      },
      saveSubStep(save_mode) {
            let substep = this.substep_cache;
            let step_type = substep.step_type_short;
            let step_id = substep.step_id;
            let takt_index = this.$route.params.takt_index;
            let step_card = this.$store.state.Ultra.projects[this.project_id].step_cards[takt_index][`${step_type}_cards`].find(card => card.id === step_id);
            let train_id = step_card.train_id;
            let taktarea_id = step_card.taktarea_id;
            let twaggon_id = step_card.twaggon_id;
            let tworkpackage_id = step_card.work_package_id;
            if (save_mode === 'update') {
              this.requestSnackbarUpdate({
                url: [
                  { projects: this.project_id },
                  { trains: train_id },
                  { taktareas: taktarea_id },
                  { twaggons: twaggon_id },
                  { tworkpackages: tworkpackage_id },
                  { [`t${step_type}steps`]: step_id },
                  { substeps: substep.id},
                ],
                update: {
                  start: substep.start,
                  duration: substep.duration,
                  day_index: substep.day_index
                }
              }).then((payload) => {
                this.updateUObject(payload)
              }).then(() => {
                this.substep_cache = {show: false, id: -1, day_index: -1};
                this.is_mouse_moved = false;
              })
            } else if (save_mode === 'create') {
              this.requestSnackbarCreate({
                url: [
                  { projects: this.project_id },
                  { trains: train_id },
                  { taktareas: taktarea_id },
                  { twaggons: twaggon_id },
                  { tworkpackages: tworkpackage_id },
                  { [`t${step_type}steps`]: step_id },
                  { substeps: ''},
                  {showWithEntitiesNormalized: ''},
                ],
                u_object: {
                  start: substep.start,
                  duration: substep.duration,
                  day_index: substep.day_index
                }
              }).then((payload) => {
                this.createUObject(payload)
              }).then(() => {
                this.substep_cache = {show: false, id: -1, day_index: -1};
              })
            }
      },
      getText(id){
        console.log(id, this.snackbar)
        return this.getUObject({type: this.snackbar.parent_type, id: id})
      },
      getWorkPackage(step_id) {
        let wp = this.getUObjectsFiltered({type: 'tworkpackages', search: {[`${this.snackbar.parent_type}`]: step_id}})
        console.log(wp, 'WP', step_id)
        return wp
      },
      extractStepType() {
      let s = this.snackbar.target_type;
      s = s.substring(1); // remove leading 't'
      s = s.slice(0, -5); // remove trailing 'steps'
      s = s[0].toUpperCase() + s.substring(1); // capitalize first letter
      return s;
    },
    }
}
</script>

<style>
.wallet-slide-left-enter {
    transform: translateX(-100%);
}

.wallet-slide-left-leave-to {
    transform: translateX(100%);
}

.wallet-slide-right-enter {
    transform: translateX(100%);
}

.wallet-slide-right-leave-to {
    transform: translateX(-100%);
}

.wallet-slide-left-enter-active,
.wallet-slide-left-leave-active,
.wallet-slide-right-enter-active,
.wallet-slide-right-leave-active {
    transition: all 0.2s ease-in-out;
}

.wallet-sidebar {
    display: flex;
    flex-direction: column;
}
.microlevel {
  height: 100%;
  width: 200%;
  /* border: 1px solid white; */
}
.microlevel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  /* border: 1px solid white; */

}
.microlevel-body {
  display: flex;
  height: calc(100% - 56px);
  /* border: 1px solid red; */

}
.microlevel-day {
  height: 100%;
  /* border: 1px solid green; */

}
.microlevel-time {
  height: calc(100% - 30px);
  width: 50px;
  /* border: 1px solid white; */
  margin-top: 30px;
}
.microlevel-day-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 30px;
  /* border: 1px solid white; */

}
.microlevel-day-body {
  position: relative;
  height: calc(100% - 30px);
  border: 1px solid;
}
.microlevel-time-slot {
  display: flex;
  width: 100%;
  /* border: 1px solid blue; */
}
.microlevel-time-slot-invisible {
  display: flex;
  width: 100%;
  /* border: 1px solid blue; */
  /* background-color: red; */
  opacity: 0.2;
}
/* .microlevel-time-slot-invisible:hover {
  background-color: red !important;
} */
.microlevel-time-slot-header {
  width: 100%;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  margin-top: -9px;
  font-size: 15px;
}



.big_black_block {
  height: calc(100vh - 48px - 26px - 62px - 41px - 10px - 31px);
}

.takt-plan-snack-bar-head,
.takt-plan-snack-bar-head>div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.takt-plan-snack-bar-head {
  padding: 0 12px 8px 12px;
}

.takt-plan-snack-bar-body-update-value-from-to-container {
  padding: 8px 16px;
}

.takt-plan-snack-bar-body-update-value-from-to-item {
  display: flex;
  flex-direction: row;
  grid-gap: 8px;
  align-items: center;
}

.takt-plan-snack-bar-footer {
  padding: 6px 24px;
}

.takt-plan-snack-bar-footer-toggle {
  display: flex;
  grid-gap: 8px;
  padding: 8px 0 16px 0;
}

.takt-plan-snack-bar-footer-buttons {
  display: flex;
  justify-content: center;
  grid-gap: 8px;
}
</style>
